export const CURRENCY = "USD";
export const STANDARD_SHIPPING = 9.99;

export const formatMoney = (value) =>
  new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: CURRENCY,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(value) || 0);

export const getCartLines = (cartItems, products) =>
  cartItems
    .map((item) => {
      const product = products.find((candidate) => candidate.id === item.id);
      if (!product) return null;
      const quantity = Math.max(1, Number(item.quantity) || 1);
      return {
        ...item,
        quantity,
        product,
        lineTotal: Number(product.price) * quantity,
      };
    })
    .filter(Boolean);

export const getOrderTotals = (cartItems, products) => {
  const lines = getCartLines(cartItems, products);
  const subtotal = lines.reduce((sum, line) => sum + line.lineTotal, 0);
  const shipping = subtotal === 0 ? 0 : STANDARD_SHIPPING;
  return { lines, subtotal, shipping, total: subtotal + shipping };
};
